export default "__VITE_ASSET__BaFcmi$n__"